import {Injectable} from "@angular/core";
import {ICommonAppSettings, MesConfigService} from "./config.service";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {BaseStateService} from "./base-state.service";

@Injectable({
  providedIn: 'root'
})
export class StateResolver {
  constructor(private configService: MesConfigService, private stateService: BaseStateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ICommonAppSettings> | Promise<ICommonAppSettings> | ICommonAppSettings {
    return this.configService.getSettings<ICommonAppSettings>().pipe(map((data: any) => {
      this.stateService.settings$.next(data);
      return data;
    }));
  }
}
